var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 75.85c-.34-.22-3-2.06-5.6-7.63-4.8-10.22-5.81-24.62-5.81-34.9v-.14A33.68 33.68 0 0063.93 2.71a37 37 0 00-28.84.45 33.83 33.83 0 00-16 17A33.42 33.42 0 0016.4 33.3c0 10.28-1 24.67-5.83 34.89C7.94 73.76 5.31 75.6 5 75.83a3.37 3.37 0 00-1.89 3.87 3.52 3.52 0 003.48 2.72h25.52a17.91 17.91 0 0035.82 0h25.49a3.56 3.56 0 003.48-2.72 3.38 3.38 0 00-1.9-3.85zM50 93.13a11 11 0 01-11-10.69h22a11 11 0 01-11 10.69zM14.53 75.45a36.08 36.08 0 001.82-3.2c3.74-7.36 6-17.22 6.74-29.43.19-3 .29-6.19.29-9.49a26.63 26.63 0 1153.25-.8v.93c0 3.29.1 6.46.29 9.49.75 12.14 3 22 6.73 29.32a34.11 34.11 0 001.82 3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.53d274b8.svg";
export { ForwardRef as ReactComponent };